import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { EASE, IMG } from "@/lib/site";
import { CtaButton } from "@/components/site/CtaButton";
import { Eyebrow } from "@/components/site/Reveal";

const LINES = [["Don't just get by.", false], ["Dominate.", true]];

export const NitricHero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  return (
    <section id="top" ref={ref} className="relative overflow-hidden bg-[#140A0C] pb-24 pt-32 sm:pt-40 lg:min-h-screen" data-testid="nitric-hero-section">
      <div className="grain" />
      <div className="absolute -left-40 bottom-0 h-[520px] w-[520px] rounded-full bg-[#FF4D4D]/15 blur-3xl" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Eyebrow className="!text-[#FF4D4D]">Gobbloo Review — No. 03 · Male vitality</Eyebrow>
          <h1 className="mt-6 font-display text-[2.4rem] font-bold leading-[1] tracking-tight text-[#F2EDE4] sm:text-6xl lg:text-[4.6rem] xl:text-[5.2rem]" data-testid="nitric-hero-headline">
            {LINES.map(([t, it], i) => (
              <span key={t} className="block overflow-hidden pb-[0.08em]">
                <motion.span className={`block ${it ? "font-serif text-[1.2em] leading-[0.9] italic font-normal text-[#FF4D4D]" : ""}`}
                  initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1.2, ease: EASE, delay: 0.35 + i * 0.14 }}>
                  {t}
                </motion.span>
              </span>
            ))}
          </h1>
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 1, ease: EASE }}
            className="mt-8 max-w-lg text-base leading-relaxed text-[#F2EDE4]/75 sm:text-lg">
            Unleash your full potential with <span className="text-[#F2EDE4]">Nitric Boost</span> — one scoop of powder a day, made to
            support sexual performance naturally through nitric oxide and healthy blood flow.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.05, duration: 1, ease: EASE }}
            className="mt-10 flex flex-wrap items-center gap-4">
            <CtaButton testId="nitric-hero-hoplink-button" placement="hero" product="nitric-boost" variant="crimson">Claim the discount</CtaButton>
            <a href="#why" data-testid="nitric-hero-learn-more" className="text-sm text-[#F2EDE4]/75 underline-offset-4 hover:text-[#F2EDE4] hover:underline">How it's meant to work</a>
          </motion.div>
        </div>
        <motion.div className="relative mx-auto w-full max-w-md lg:col-span-5"
          initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.4, ease: EASE, delay: 0.5 }}>
          <div className="aspect-[4/5] overflow-hidden rounded-[2rem] [clip-path:polygon(12%_0,100%_0,100%_100%,0_100%,0_12%)]">
            <motion.img style={{ scale }} src={IMG.nitricHero} alt="Athletic man in dramatic low light" className="h-full w-full object-cover" />
          </div>
          <div className="absolute -bottom-8 -right-2 w-[48%] overflow-hidden rounded-2xl bg-white p-2 shadow-2xl sm:-right-8" data-testid="nitric-hero-jars">
            <img src="/nitric-jars.webp" alt="Nitric Boost Ultra jars — buy 6, get 1 free" className="w-full" />
          </div>
          <motion.img src="/nitric-guarantee-badge.png" alt="60-day money back guarantee" data-testid="nitric-hero-badge"
            animate={{ rotate: [0, 8, 0] }} transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
            className="absolute -top-6 right-2 w-24 drop-shadow-xl sm:-right-6 sm:w-28" />
          <div className="absolute -bottom-6 left-4 hidden rounded-2xl border border-[#F2EDE4]/15 bg-[#140A0C]/85 p-4 backdrop-blur-xl sm:-left-8 sm:block sm:p-5">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF4D4D]">One scoop a day</p>
            <p className="mt-1 font-display text-xl font-bold text-[#F2EDE4]">Nitric Boost</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
